module.exports = __webpack_public_path__ + "img/view-modal-icon.fb23475e.svg";